import { render, staticRenderFns } from "./AcademicReferencesSuperior.vue?vue&type=template&id=2c7beb14&"
import script from "./AcademicReferencesSuperior.vue?vue&type=script&lang=js&"
export * from "./AcademicReferencesSuperior.vue?vue&type=script&lang=js&"
import style0 from "./AcademicReferencesSuperior.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c7beb14')) {
      api.createRecord('2c7beb14', component.options)
    } else {
      api.reload('2c7beb14', component.options)
    }
    module.hot.accept("./AcademicReferencesSuperior.vue?vue&type=template&id=2c7beb14&", function () {
      api.rerender('2c7beb14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/candidates/academic-references/AcademicReferencesSuperior.vue"
export default component.exports